import React from "react";
import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";

const SelectionAlertRow = ({
  selectedCount,
  onDelete,
  onDownload,
  onAssign,
  onCreateGroup,
  onClear,
  showAssign,
  showCreateGroup,
  showDownload,
  downloading,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div
      className="creative-library__selection-alert"
      role="status"
      aria-live="polite"
    >
      <div className="creative-library__selection-alert-info">
        <span className="creative-library__selection-alert-count">
          {selectedCount}
        </span>
        <span className="creative-library__selection-alert-text">
          item{selectedCount !== 1 ? "s" : ""} selected
        </span>
      </div>
      <div className="creative-library__selection-alert-actions">
        {showCreateGroup && (
          <>
            <button
              type="button"
              className="creative-library__selection-alert-link"
              onClick={onCreateGroup}
              aria-label="Create group from selected items"
            >
              Create Group
            </button>
            <span className="creative-library__selection-alert-separator">
              &middot;
            </span>
          </>
        )}
        {showAssign && (
          <>
            <button
              type="button"
              className="creative-library__selection-alert-link"
              onClick={onAssign}
              aria-label="Assign selected items"
            >
              Assign
            </button>
            <span className="creative-library__selection-alert-separator">
              &middot;
            </span>
          </>
        )}
        {showDownload && (
          <>
            <button
              type="button"
              className={`creative-library__selection-alert-link${downloading ? " creative-library__selection-alert-link--disabled" : ""}`}
              onClick={downloading ? undefined : onDownload}
              disabled={downloading}
              aria-label="Download selected items"
            >
              {downloading && <LoadingOutlined className="creative-library__selection-alert-link-icon" />}
              {downloading ? "Downloading..." : "Download"}
            </button>
            <span className="creative-library__selection-alert-separator">
              &middot;
            </span>
          </>
        )}
        <button
          type="button"
          className="creative-library__selection-alert-link creative-library__selection-alert-link--danger"
          onClick={onDelete}
          aria-label="Delete selected items"
        >
          Delete
        </button>
        <button
          type="button"
          className="creative-library__selection-alert-close"
          onClick={onClear}
          aria-label="Clear selection"
        >
          <CloseOutlined />
        </button>
      </div>
    </div>
  );
};

export default SelectionAlertRow;
